import ToppingItem from '../ToppingItem/topping-item';

export default ToppingItem;